module.exports = __webpack_public_path__ + "img/move_channel_the_living_light.d465a93b.png";